/* AddInstructionsSummaryComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./AddInstructionsSummaryRenderer");

/**
 * AddInstructionsSummaryComponent
 *
 * Component for displaying the summary of instruction linking results
 * Shows success/failure/skipped counts and detailed error messages
 *
 * @class
 * @extends EventEmitter
 */
class AddInstructionsSummaryComponent extends EventEmitter {
    /**
     * @param {Object} summaryData - Summary data with success/failure/skipped counts and errors
     * @param {number} summaryData.totalInstructions - Total number of instructions attempted
     * @param {number} summaryData.totalPlatforms - Total number of platforms
     * @param {number} summaryData.total - Total number of link attempts
     * @param {number} summaryData.successCount - Number of successful links
     * @param {number} summaryData.failureCount - Number of failed links
     * @param {number} summaryData.skippedCount - Number of skipped links (already linked)
     * @param {Array<string>} summaryData.errors - Array of error messages
     * @param {Object} logger - Logger instance
     */
    constructor(summaryData, logger) {
        super();
        this._logger = logger;
        this._summaryData = summaryData;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    get summaryData() {
        return this._summaryData;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    /**
     * Register any listeners needed for this component
     */
    _registerListeners() {}

    /**
     * Unregister listeners for this component
     */
    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    /**
     * Get the renderer instance for this component
     * @returns {AddInstructionsSummaryRenderer}
     */
    getRenderer() {
        return this._renderer;
    }

    /**
     * Clean up and shutdown the component
     * @returns {Promise}
     */
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
                this._summaryData = undefined;
            },
            (err) => {
                this._logger &&
                    this._logger.warn(
                        {error: err},
                        "AddInstructionsSummaryComponent.shutdown() error"
                    );
            }
        );
    }

    /**
     * Handler for the OK button: resolves the UI context
     */
    sendOk() {
        this._context.resolve({});
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }
}

module.exports = AddInstructionsSummaryComponent;
